import {
    GET_ORDER_REWARDS,
    GET_REWARDS_REQUEST,
} from 'yoda-checkout-components/lib/actionTypes/RewardsActionTypes';

export const getOrderRewards = (payload) => ({
    type: GET_ORDER_REWARDS,
    payload,
});

export const getLatestRewards = (payload) => ({
    type: GET_REWARDS_REQUEST,
    payload,
});

export default { getOrderRewards, getLatestRewards };
